import React, { useEffect, useRef } from 'react';
import './WhatsAppButton.css';

function WhatsAppButton() {
    const buttonRef = useRef(null);

    useEffect(() => {
        // Randomly start the shaking between 10 to 30 seconds
        const shakeInterval = setInterval(() => {
            buttonRef.current.classList.add('shake-animate');

            // Stop shaking after 1 second
            setTimeout(() => {
                buttonRef.current.classList.remove('shake-animate');
            }, 1000);
        }, Math.random() * (3000 - 1000) + 1000);

        return () => {
            clearInterval(shakeInterval);
        }
    }, []);

    return (
        <a href="https://wa.link/clgogu" target="_blank" rel="noopener noreferrer">
            <div className="whatsapp-button" ref={buttonRef}>
                <img src="/icons/WhatsApp.svg" alt="WhatsApp" />
            </div>
        </a>
    );
}

export default WhatsAppButton;
